import React, {useState, useEffect} from 'react'
import { Link } from "react-scroll"
import { Link as DomLink, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Carousel, Image, Navbar, Nav, Table} from 'react-bootstrap';
import './HomePage.css'
import titleImage from '../assets/title-image.png';
import working from '../assets/working.jpeg';
import mobileAndLaptopView from '../assets/mobileAndLaptopView.png';
// import signupPage from '../assets/signupPage.jpeg';
// import adminPage from '../assets/adminPage.jpeg';
// import chamberPage from '../assets/chamberPage.jpeg';
// import graphPage from '../assets/graphPage.jpeg';
import loginPage from '../assets/working-new-1.png';
import hospitalsPage from '../assets/working-new-2.png';
import roomsPage from '../assets/working-new-3.png';
import patientPage from '../assets/working-new-4.png';
import seniorCitizenGraph1 from '../assets/seniorCitizenGraph-1.jpeg';
import seniorCitizenGraph2 from '../assets/seniorCitizenGraph-2.jpeg';
import seniorCitizenGraph3 from '../assets/seniorCitizenGraph-3.jpeg';
import seniorCitizenGraph4 from '../assets/seniorCitizenGraph-4.jpeg';
import healthcareServicesTable from '../assets/healthcare-services-table.jpeg';
import healthcareServicesChart from '../assets/healthcare-services-chart.jpeg';
import feature1 from '../assets/feature-1.png';
import feature2 from '../assets/feature-2.png';
import feature3 from '../assets/feature-3.png';
import feature4 from '../assets/feature-4.png';
import feature5 from '../assets/feature-5.png';
import mission from '../assets/Vision-mission.jpeg';
import Birac from '../assets/birac-logo.jpg';
import crescent from '../assets/crescent.jpg';
import SaraswatiMedicalClg from '../assets/Saraswati-Medical-College.jpeg';
import IEEE from '../assets/IEEE-vjti.png';
import logo from '../assets/isoport-logo.jpeg';
import { useAuth } from '../contexts/AuthContext';

const HomePage = () => {
    const {currentUser} = useAuth();
    const history = useHistory();
    function getWindowWidth() {
        const { innerWidth: width} = window;
        return width;
      }
      
      function useWindowWidth() {
        const [windowWidth, setWindowWidth] = useState(getWindowWidth());
      
        useEffect(() => {
          function handleResize() {
            setWindowWidth(getWindowWidth());
          }
      
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
        }, []);
      
        return windowWidth;
      }

    const [index, setIndex] = useState(0);
    const [navbar, setNavbar] = useState(false);
    const width =useWindowWidth();

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const signupHandler=(e)=>{
      history.push("/signup");
  }

  const loginHandler=(e)=>{
    history.push("/login");
}

  const dashboardHandler=(e)=>{
    if(currentUser && currentUser.role==="superadmin") return history.push("/hospitals");
    if(currentUser && currentUser.role==="admin") return history.push(currentUser.path.toLowerCase());
    if(currentUser && currentUser.role==="user") return history.push(currentUser.path.toLowerCase());
}

  const changeNavbarBackground = () => {
    if (window.scrollY >= 112) {

      setNavbar(true)
    } else {
      setNavbar(false)
    }
  }
  window.addEventListener("scroll", changeNavbarBackground)

    return (
        <>
        <Navbar variant={navbar?"dark":"light"} expand='lg' className={navbar ? "sticky-top nav-colored" : "sticky-top nav-transparent"} id='navbar-component' >
            <Container fluid className='navbar-styles navbar-container'>
                <Navbar.Brand>
                    <Link to='/' spy={true} smooth={true} offset={0} duration={500} activeClass='active'>
                       <Image className="logo" src={logo}/>
                    </Link>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls='basic-navbar-nav'/>

                <Navbar.Collapse id='basic-navbar-nav'>
                <Nav className='ml-auto'>

                    <Nav.Link className='nav-link-style'>
                        <Link to='about' spy={true}  smooth={true} offset={-300} duration={500} >
                            About
                        </Link>
                    </Nav.Link>

                    <Nav.Link className='nav-link-style'>
                        <Link to='vision-mission' spy={true}  smooth={true} offset={width<762?-250:0} duration={500}>
                            Vision & Mission
                        </Link>
                    </Nav.Link>

                    <Nav.Link className='nav-link-style'>
                        <Link to='business-partner'  spy={true}  smooth={true} offset={width<762?-220:0} duration={500}>
                            Partners
                        </Link>
                    </Nav.Link>

                    <Nav.Link className='nav-link-style'>
                        <Link to='products'  spy={true}  smooth={true} offset={0} duration={500}>
                            Products
                        </Link>
                    </Nav.Link>

                    <Nav.Link className='nav-link-style'  href='https://www.youtube.com/channel/UC89NqYfl-VntaeO4vaVYPgw' >
                        <span className="router-links mr-0" >
                            Video
                        </span>
                    </Nav.Link>

                    <Nav.Link className='nav-link-style'>
                        <Link to='contactUs' spy={true}  smooth={true} offset={width<762?-200:0} duration={500} delay={200}>
                            Contact Us
                        </Link>
                    </Nav.Link>

                    {!currentUser?
                        <>
                        {/* <Nav.Link className='nav-link-style'>
                            <DomLink className="router-links mr-3" to='/login'>
                                Login
                            </DomLink>
                        </Nav.Link> */}

                        <Button className='btn-effect btn-login sp-effect' onClick={loginHandler}>
                            <span className="router-links router-links-btn">
                                Sign In
                            </span>
                        </Button>

                        {/* <Button className='btn-effect sp-effect' onClick={signupHandler}>
                            <span className="router-links router-links-btn">
                                Sign Up
                            </span>
                        </Button> */}
                        </>:                         
                        <Button className='btn-effect sp-effect' onClick={dashboardHandler}>
                            <span className="router-links router-links-btn">
                                Dashboard
                            </span>
                        </Button>
                    }

                    
                </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
            
        <section id="about">
            <Container fluid className="about-container">
                <Row>
                    <Col className="about-left-container" md={6}>
                        <h3 className="heading-1">Multi-Parameter Patient Monitor <br/>AI driven Early Warning System <br/>SMART Robotic Nurse</h3>
                        <h3 className="heading-2">Integrating healthcare infra with wearable sensors, IoT, Robotics & AI</h3>
                        <h3 className="heading-3">SMART Healthcare Products- AI enabled IoT platform <br/>SMART Hospital Multi-Unit Ward Facility (B2B)<br/>Senior-care at Home (B2C)<br/></h3>
                        
                    </Col>
                    <Col className="mt-3" md={6} className="title-image-container">
                        <Image fluid className="title-image" src = {titleImage} alt="Group_18"/>
                    </Col>
                </Row>
            </Container>
        </section>

        <section id="vision-mission">
            <Container className="vision-mission-container">
                <h1 className="vision-heading">Vision & Mission</h1>
                <p className="vision-description"><strong>Vision:</strong> Redefining healthcare by integrating healthcare infrastructure with IoT and AI/ML engines to provide improved treatment
                    outcomes, reduced operating costs, better workflow, improved performance and patient experience for healthcare providers by
                    synchronized use of engineering and technology.
                </p>
                <Row>
                    <Col className="vision-image-container">
                        <Image fluid className="vission-image" fluid src={mission}/>
                    </Col>
                </Row>
            </Container>
        </section>

        <section id="business-partner">
                <Container className="business-partner-container">
                    <h1 className="partners">Partners</h1>
                    <hr></hr>
                    <Row>
                        <Col xl={5} sm={12}>
                            <h2 className="partners-heading heading-bi">Business Incubation Partner</h2>
                            <Row>
                                <Col xs={4} md={3} lg={3} xl={4}>
                                    <Image fluid className="birac" fluid src={Birac}/>
                                </Col>
                                <Col xs={4} md={3} lg={3} xl={4}>
                                    <Image fluid className="birac" fluid src={crescent}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col xl={4} sm={6}>
                            <h2 className="partners-heading heading-tp"> Technical Partner</h2>
                            <Image fluid className="ieee" src={IEEE}/>
                        </Col>
                        <Col xl={3} sm={6} className="mt-3 mt-sm-0">
                            <h2 className="partners-heading heading-mp"> Medical Partner</h2>
                            <Image fluid className="clg-logo" fluid src={SaraswatiMedicalClg}/>
                        </Col>
                    </Row>
                    <hr></hr>
                    <h2 className="business-exec"> Executive Summary</h2>
                    <p className="bus-exec-p"><strong>USP:</strong> To deploy and own SMART ICU infrastructure, sensors and instruments which generate patient data, control flow of patient data
                        and use proprietary AL/ML engines<br/>
                        <strong>Target Customer:</strong> IsoPort is focusing on immunocompromised, seriously ill and elderly patients who need protection from Hospital
                        Acquired Infections and Labor intensive care.<br/>
                        <strong>Product Features:</strong> IsoPort Isolation Ward, a multi room prefabricated hospital ward providing double door rooms with pressure
                        differential, dedicated HVAC, ventilation and air purifiers</p>
                    <hr></hr>
                    <h2 className="bus-ic">Incorporation Status & Registered Trademark</h2>
                    <ul className="pt-2">
                        <li>Presently incorporated under the name, Isoport Chambers Pvt. Ltd.</li>
                        <li>Registered with MSME and Startup India</li>
                    </ul>
                </Container>
        </section>

        <section id="scaleOfProblem">
            <Container fluid className="scaleOfProblem-container">
                {/* <Row>
                    <Col md={5}>
                        <h1 className="text-left mb-4">Scale of Problem</h1>
                    </Col>
                    <Col md={7}>
                        <hr></hr>
                    </Col>
                </Row> */}
                <h1 className="text-center mb-4">Scale of Problem</h1>
                
                <ul className="scaleOfProblem-list">
                    <li>Most of Developed and Developing world will have over 20% of population over 60 years by 2050</li>
                    <li>There will not be enough on call Nurses, Doctors & Hospital Beds for All</li>
                    <li>Senior Citizens do not need to go to Hospitals for minor checkup</li>
                    <li>They want to stay at home and need Home ICU with Active Monitoring</li>
                </ul>
                <div className="senior-citizen-graph">
                    <Image className="senior-citizen-graph-image1" src={seniorCitizenGraph1}/>
                    <Image className="senior-citizen-graph-image2" src={seniorCitizenGraph2}/>
                    <Image className="senior-citizen-graph-image3" src={seniorCitizenGraph3}/>
                    <Image className="senior-citizen-graph-image4" src={seniorCitizenGraph4}/>
                </div>
            </Container>
        </section>

        <section id="healthcare-service">
            <Container fluid className="healthcare-service-container">
                <h1 className="text-center mb-5">HealthCare Service Quality Differentiation</h1>
                <div className="healthcare-service-list">
                    <ul>
                        <li><span className="healthcare-service-list-item">Geographical Inequality:</span> Some States have better Health Infra than others</li>
                        <li><span className="healthcare-service-list-item">Urban vs Rural Inequality:</span> Better Hospitals, Doctors & ICUs are concentrated in Cities Tier 2 & Tier 3 city Seniors &patients need early warning signals for reaching cities</li>
                        <li><span className="healthcare-service-list-item">Rich vs Poor Inequality:</span> Rich are able to access better and faster healthcare</li>
                        <li><span className="healthcare-service-list-item">Old vs Young Inequality:</span> Seniors, unstable & Poor patients can not afford/ sustain frequent hospital visits</li>
                    </ul>
                </div>
                <Row>
                    <Col lg={6} className="mb-3 h-100">
                        <Image fluid src={healthcareServicesTable}/>
                    </Col>
                    <Col lg={6}>
                        <Image fluid src={healthcareServicesChart}/>
                    </Col>
                </Row>
            </Container>
        </section>
        
        <section id="products">
            <Container fluid className="products-container">
                <h2 className="text-center">Smart ICU @ Hospital</h2>
                <div className="icu-hospital">
                    <div className="product-box">
                        <Image className="product-image" fluid src={feature1}/>
                        <h4 className="product-list-heading">Standalone Unit</h4>
                        <ul className="product-list">
                            <li className="product-item">Single chamber unit</li>
                            <li className="product-item">Double door design</li>
                            <li className="product-item">Air purifier</li>
                            <li className="product-item">UV light in exhaust</li>
                            <li className="product-item">Window AC</li>
                            <li className="product-item">Smart ICU monitors</li>
                        </ul>
                        
                    </div>
                
                    <div className="product-box">
                    <Image className="product-image" fluid src={feature2}/>
                        <h4 className="product-list-heading">5 unit Ward</h4>
                        <ul className="product-list">
                            <li className="product-item">5 unit design</li>
                            <li className="product-item">Double door pressure differential</li>
                            <li className="product-item">Dedicated HVAC</li>
                            <li className="product-item">Air purifier</li>
                            <li className="product-item">UV light in exhaust</li>
                            <li className="product-item">Smart ICU monitors</li>
                        </ul>
                    </div>
                
                    <div className="product-box">
                        <Image className="product-image" fluid src={feature3}/>
                        <h4 className="product-list-heading">1O unit Ward</h4>
                        <ul className="product-list">
                            <li className="product-item">10 unit design</li>
                            <li className="product-item">Double door pressure differential</li>
                            <li className="product-item">Dedicated HVAC</li>
                            <li className="product-item">Air purifier</li>
                            <li className="product-item">UV light in exhaust</li>
                            <li className="product-item">Smart ICU monitors</li>
                        </ul>
                    </div>
                </div>

                <h2 className="text-center mt-5">ICU @ Home</h2>
                <div className="icu-home">
                    <div class="product-box-1">
                        <Image className="product-image-1" fluid src={feature5}/>
                        <h5 className="product-list-heading-1">Multi Parameter Remote Health Monitoring System</h5>
                        <ul className="product-list-1">
                            <li className="product-item-1">Body Wearable Wristband</li>
                            <li className="product-item-1">GPS Tracker Arm Band</li>
                            <li className="product-item-1">Easy ECG Monitoring</li>
                            <li className="product-item-1">Air Quality sensors</li>
                            <li className="product-item-1">Mobile & Desktop enabled</li>
                            <li className="product-item-1">Based on AI/ML models</li>
                            <li className="product-item-1">Robotic Assistantance</li>
                        </ul>
                    </div>
                </div>     

            </Container>
        </section>

        <section id="info">
            <Container fluid className="info-container">
                <h2 className="mb-5 text-center">How IsoPort Multi Parameter Remote Monitoring System helps?</h2>
                <Row>
                    <Col className="info-image-container" lg={6}>
                        <Image fluid className="info-image" fluid src={working}/>
                    </Col>
                    <Col lg={6}>
                        <div>
                            <ul className="info-list mt-sm-5 mt-md-0">
                                <li>Senior citizens often have chronic health complications which can be controlled if the signs are detected early</li>
                                <li>Any abnormal changes are seen directly on the dashboard on the dashboard and the caretaker is alerted so that required action can be taken, before an emergency rises</li>
                                <li>This can be used particularly for senior citizens/ unstable patients who are unable to communicate their difficulties</li>
                                <li>Goal is to avoid travel to hospital and manage higher-acuity, higher-risk patients within their own home</li>
                                <li>Evidence shows that hospital at home programs produce better clinical outcomes, improve patient satisfaction, and reduce the cost of care</li>
                                <li>Remote Monitoring System will allow patients from remote/rural/poorly accessible locations to get Early Warning Signals to plan their travel and access healthcare</li>
                                <li>Public Health Service can plan for larger cost effective hospitals</li>
                                <li>Economic monitoring system will make available door step service to Seniors</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>

        <section id="carousels">
            <Container fluid className="carousels-container">
                <Carousel fade activeIndex={index} onSelect={handleSelect} className="carousel-dark">
                    <Carousel.Item>
                        <Image fluid
                        className="d-block w-100 carousel-image"
                        src={loginPage}
                        alt="First slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image fluid
                        className="d-block w-100 carousel-image"
                        src={hospitalsPage}
                        alt="Second slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image fluid
                        className="d-block w-100 carousel-image"
                        src={roomsPage}
                        alt="Third slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <Image fluid
                        className="d-block w-100 carousel-"
                        src={patientPage}
                        alt="Fourth slide"
                        />
                    </Carousel.Item>
                </Carousel>
            </Container>
        </section>

        <section id="look-and-feel">
            <Container fluid className="look-and-feel-container">
                <h1 className="text-center mb-5">Look & Feel of the system</h1>
                <Row>
                    <Col md={6} className="look-and-feel-left-container">
                        <ul className="mt-lg-4 look-and-feel-list">
                            <li>Body Wearable Wristband for measuring Heartrate, Temperature, Blood Pressure and Oxygen concentration</li>
                            <li>GPS Tracker Arm Band for geolocation</li>
                            <li>Economical detachable portable ECG Monitor</li>
                            <li>Air Quality Sensors</li>
                            <li>Wall Mounted wifi IoT enabled CPU for data collection, local alarm system and cloud upload</li>
                            <li>Mobile & Desktop enabled Dashboard</li>
                            <li>AI/ML models for generation of early warning signals</li>
                            <li>Robotic Assistant for visual and audio communication</li>
                        </ul>
                    </Col>
                    <Col md={6}  className="look-and-feel-right-container">
                        <Image fluid src={mobileAndLaptopView} alt="mobile and desktop view"/>
                    </Col>
                </Row>
            </Container>
        </section>

        <section id="contactUs">
            <Container fluid className="contactUs-container">
                <Row>
                    <Col lg={5} className="mb-5 mb-lg-0">
                        <h2>IsoPort Chamber Pvt Ltd</h2>
                        <p className="contactus-subheading">For More Details please reach out to IsoPort Chamber Pvt Ltd</p>
                        <p className='footer-contact'><i class="fas fa-phone"></i> +91-9075840141/ +91-9372022070</p>
                        <p className='footer-contact'><i class="fas fa-envelope"></i><a className="email-link footer-links" href="mailto:admin@isoportchamber.com" > admin@isoportchamber.com</a></p>
                        <a class="social-icon fab fa-twitter" aria-hidden="true" href="https://twitter.com/isoportchamber" target="_blank"></a>
                        <a class="social-icon fab fa-facebook" aria-hidden="true" href="https://www.facebook.com/IsoPort-Chamber-Private-Ltd-101300568253177/" target="_blank"></a>
                        <a class="social-icon fa fa-linkedin" aria-hidden="true" href="https://www.linkedin.com/company/isoport-chamber-pvt-ltd" target="_blank"></a>
                        <a class="social-icon fa fa-youtube" aria-hidden="true" href="https://www.youtube.com/channel/UC89NqYfl-VntaeO4vaVYPgw" target="_blank"></a>
                    </Col>
                </Row>
                <div className='text-center mt-5 copyright'>
                    <span>&copy; {new Date().getFullYear()} Isoport Chamber / All rights reserved / Privacy</span>
                </div>
            </Container>
        </section>
        </>
    )
}

export default HomePage;